import { PERSONA_TEMPERAMENT_AXES } from "./vocabulary.js";
import { PERSONA_INFLUENCE_SNIPPETS, PERSONA_TEMPERAMENT_SNIPPETS } from "./snippets.js";
/**
 * Render the STRUCTURED part of a persona (influences + temperament) into the
 * prompt snippet injected next to the R3.1 sonic-trait snippet (spec §5.3).
 *
 * Order: `influences -> temperament(discipline, boldness, experimental)`, joined
 * with ", ". `bio` is NOT rendered — it is editorial only (§12 #5). Neutral
 * (`3`) and absent axes contribute nothing. `{}` -> "".
 *
 * This is the single point that knows the persona snippet texts — it mirrors the
 * contract of `renderSonicTraits`.
 */
export function renderPersona(persona) {
    const parts = [];
    for (const term of persona.influences ?? []) {
        parts.push(PERSONA_INFLUENCE_SNIPPETS[term]);
    }
    const temperament = persona.temperament;
    if (temperament) {
        for (const axis of PERSONA_TEMPERAMENT_AXES) {
            const value = temperament[axis];
            if (value === undefined)
                continue;
            const snippet = PERSONA_TEMPERAMENT_SNIPPETS[axis][value];
            if (snippet)
                parts.push(snippet);
        }
    }
    return parts.join(", ");
}
//# sourceMappingURL=render.js.map